export { reducer as partner } from './ducks/partner'
